import { render, staticRenderFns } from "./SalaryCompoRatioChart.vue?vue&type=template&id=6820bd82&"
import script from "./SalaryCompoRatioChart.vue?vue&type=script&lang=js&"
export * from "./SalaryCompoRatioChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports